// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__Hw2ZL","sliderBox":"Switch_sliderBox__U-sMF","text":"Switch_text__lJQ5I","textActive":"Switch_textActive__lATVg"};